<template>
    <div>
        <b-row>
            <b-col>
                <b-form @submit.prevent="save">
                    <b-card>

                        <b-form-row>

                            <b-col cols="12" class="text-left">
                                <lg-finder-pessoa id="finderPessoa" @onSelect="(item) => (form.pessoa = item)"
                                    ref="finderPessoa" title="PESSOA - LISTAR">
                                </lg-finder-pessoa>
                                <lg-form-input-finder v-model="form.pessoa" fieldDescription="nome" label="Pessoa:*"
                                    invalidFeedback="Responsável deve ser informada!" description="">
                                    <template #prepend>
                                        <b-button @click="$refs.finderPessoa.show()" class="btn-input-finder" pressed>
                                            <b-icon icon="search" />
                                        </b-button>
                                    </template>
                                </lg-form-input-finder>


                            </b-col>

                        </b-form-row>



                        <b-form-row>
                            <b-col cols="12" class="text-left">
                                <lg-finder-tipo-estado-conservacao id="finderTipoEstadoConservacao"
                                    @onSelect="(item) => (form.tipoEstadoConservacao = item)"
                                    ref="finderTipoEstadoConservacao" title="Tipo Estado Conservação - LISTAR">
                                </lg-finder-tipo-estado-conservacao>

                                <lg-form-input-finder v-model="form.tipoEstadoConservacao" fieldDescription="descricao"
                                    label="Tipo Estado Conservação:*" invalidFeedback=" " description="">
                                    <template #prepend>
                                        <b-button @click="$refs.finderTipoEstadoConservacao.show"
                                            class="btn-input-finder" pressed>
                                            <b-icon icon="search" />
                                        </b-button>
                                    </template>
                                </lg-form-input-finder>


                            </b-col>

                        </b-form-row>

                        <b-form-row>
                            <b-col cols="10" class="text-left">
                                <lg-form-input invalidFeedback="Informe o a descrição" description=""
                                    v-model="form.descricao" label="Descrição*" maxlength="200" />
                            </b-col>


                        </b-form-row>
                        <b-form-row>
                            <b-col cols="8">
                                <lg-form-date description="" v-model="form.data" typeDatepicker="date"
                                    label="Data de Avaliação*" />
                            </b-col>
                        </b-form-row>
                        <b-form-group label="Situação:*" label-for="radio" class="ml-3">

                            <b-form-row>
                                <b-col cols="8">
                                    <b-form-radio-group id="radio" v-model="form.situacao" class="pt-2"
                                        :options="['Ativo', 'Inativo']"
                                        :aria-describedby="ariaDescribedby"></b-form-radio-group>

                                </b-col>
                            </b-form-row>
                        </b-form-group>

                    </b-card>
                </b-form>
            </b-col>
        </b-row>

        <div class="images-container" v-if="modal">
            <img :src="imgAceitar" class="img" alt="icone pdf" @click="salvar" />
            <img :src="imgFechar" class="img" alt="icone pdf" @click="fecharModal" />
        </div>

    </div>
</template>
<script>
import { getContext } from "@/core/auth";
import FecharIcon from "@/core/assets/icons/fechar.png";
import AceitarIcon from "@/core/assets/icons/aceitar.png";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormCheckbox from "@/core/components/Form/LgFormCheckbox.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFinderPessoa from "@/components/Finders/LgFinderPessoa.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFinderTipoEstadoConservacao from "@/components/Finders/LgFinderTipoEstadoConservacao.vue";
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import LgFormInputNumber from '@/core/components/Form/LgFormInputNumber.vue';
import EstadoConservacaoIBPService from "@/core/api/EstadoConservacaoIBPService";

export default {
    components: {
        LgFormSelect,
        LgFormInput,
        LgFormConstSelect,
        LgFinderTipoEstadoConservacao,
        LgFormCheckbox,
        LgFormDate,
        LgFormInputNumber,
        LgFinderPessoa,
        LgFormInputFinder
    },
    mixins: [FormResourceMixin, ListResourceMixin],
    props: {
        id: Number,
        modal: Boolean
    },
    data() {
        return {
            imgAceitar: AceitarIcon,
            imgFechar: FecharIcon,

            form: {
                descricao: '',
                data: '',
                pessoa: {id: null},
                situacao: null,
                tipoEstadoConservacao: {id: null},

            },
        };
    },
    async beforeMount() {
        this.$estadoConservacaoIBPService = new EstadoConservacaoIBPService();
        this.form.itemBemPermanente = {id: this.id}
    },



    methods: {
        salvar() {

            if (!this.form.pessoa.id) {
                this.$notify({
                    type: "danger",
                    message: 'Pessoa é obrigatório',
                });

                return;
            }

            if (!this.form.tipoEstadoConservacao.id) {
                this.$notify({
                    type: "danger",
                    message: 'Tipo Estado Conservação é obrigatório',
                });

                return;
            }



            if (!this.form.descricao) {
                this.$notify({
                    type: "danger",
                    message: 'Descrição é obrigatória',
                });

                return;
            }


            if (!this.form.data) {
                this.$notify({
                    type: "danger",
                    message: 'Data é obrigatória',
                });

                return;
            }


            if (!this.form.situacao) {
                this.$notify({
                    type: "danger",
                    message: 'Situação é obrigatória',
                });

                return;
            }

            this.form.situacao = this.form.situacao =='Ativo'?1:0;

            this.form.repCriacao = getContext().usuario.nome;

            this.$estadoConservacaoIBPService.salvar(this.form).then(response => {
                this.$notify({
                    type: "success",
                    message: response.data,
                });
                this.fecharModal();
            })


        },
        fecharModal() {
            this.$emit('fecharModal');
        },

        editar() {
            this.$notify({
                type: "danger",
                message: 'Esse registro não pode ser editado. Por favor, inclua um novo',
            });

        },

    },
};
</script>
<style>
.hand-pointer {
    cursor: pointer;
}
</style>